let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("cT2oL")).then(() => parcelRequire('ijZ4A'));